import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';



import {

  ProfileResponse,

  UpdatePasswordRequest,

  UpdatePasswordResponse,

  UpdateProfileRequest,

} from '@oneComply/core/models/profile.model';

import { environment } from '@environments/environment';



@Injectable({ providedIn: 'root' })

export class ProfileService {

  private readonly http = inject(HttpClient);



  getMe(): Observable<ProfileResponse> {

    return this.http.get<ProfileResponse>(`${environment.apiUrl}/auth/me`);

  }



  /**

   * Identity updates are proxied server-side to OneAuth by DenunciaNR1 API.

   */

  updateProfile(payload: UpdateProfileRequest): Observable<ProfileResponse> {

    return this.http.patch<ProfileResponse>(`${environment.apiUrl}/auth/profile`, payload);

  }



  updateLocale(locale: UpdateProfileRequest['locale']): Observable<ProfileResponse> {

    return this.updateProfile({ locale });

  }



  updatePassword(payload: UpdatePasswordRequest): Observable<UpdatePasswordResponse> {

    return this.http.patch<UpdatePasswordResponse>(

      `${environment.apiUrl}/auth/password`,

      payload,

    );

  }

}


